export const TRANSFER_STATES = Object.freeze({
  ABORTED: 'aborted',
  BLOCKED: 'blocked',
  DOWNLOADABLE: 'downloadable',
  DOWNLOADING: 'downloading',
  EXPIRED: 'expired',
  FINISHED: 'finished',
  INIT: 'init',
  INVALID: 'invalid',
  PASSWORD_PROTECTED: 'password_protected',
  PAUSED: 'paused',
  PROCESSING: 'processing',
  RECAPTCHA: 'recaptcha',
  SPAM: 'spam',
  STARTED: 'started',
});
